import { useEffect } from 'react';

// Shared Travelpayouts White Label (wl_id=22421) loader.
//
// The TP WL is a self-mounting third-party bundle: on script execution it
// scans the DOM for `#tpwl-search` / `#tpwl-tickets` and hydrates them
// (rendering its Shadow-DOM search UI in place). It does NOT observe the
// DOM for later mount points, so a React SPA that swaps those nodes on
// route change cannot rely on a single script execution to service every
// page that needs the WL.
//
// Cheapora's contract:
//   • This hook injects the official TP script exactly ONCE per document
//     lifetime (guarded by a stable DOM id). Only one loader is ever
//     present — no duplicates.
//   • Home (/) and Flights (/flights) are the two routes that render the
//     WL. The `<NavLink reloadDocument>` prop is applied to the header
//     links pointing at these routes so that navigating between them
//     performs a full document load — this guarantees a fresh TP WL
//     bootstrap on each page without violating the "no duplicate loaders"
//     rule.

const TPWL_SCRIPT_ID = 'tp-wl-22421';
const TPWL_SRC = 'https://tpemd.com/wl_web/main.js?wl_id=22421';

export default function useTravelpayoutsLoader() {
  useEffect(() => {
    if (document.getElementById(TPWL_SCRIPT_ID)) return;
    const script = document.createElement('script');
    script.id = TPWL_SCRIPT_ID;
    script.async = true;
    script.type = 'module';
    script.src = TPWL_SRC;
    script.setAttribute('nowprocket', '');
    script.setAttribute('data-noptimize', '1');
    script.setAttribute('data-cfasync', 'false');
    script.setAttribute('data-wpfc-render', 'false');
    script.setAttribute('seraph-accel-crit', '1');
    script.setAttribute('data-no-defer', '1');
    document.head.appendChild(script);
    // No unmount cleanup: keep the loader in the DOM so a second visit to
    // the same route (during the same document lifetime) is a no-op.
  }, []);
}
